import axios from "axios";

export default class ViaCepService{
    resource = 'https://viacep.com.br/ws/';
    // @ts-ignore
    /*list(consulta): any {
        return this.Api.get(`${config.API_URL}${this.resource}${consulta}`);
    }*/

    consultaCep(cep: any): any {
        return axios.get(this.resource+cep+'/json/')
            .then((response) => {
                return response
            });
    }
}